import { render } from "./penafielView.vue?vue&type=template&id=3daf77b5"
import script from "./penafielView.vue?vue&type=script&lang=js"
export * from "./penafielView.vue?vue&type=script&lang=js"

import "./penafielView.vue?vue&type=style&index=0&id=3daf77b5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__